// Shared i18n helper functions used across multiple components.

/**
 * Translates a backend session mode string to its localized label.
 *
 * @param {Function} t - i18next translation function (must be from a useReadyTranslation-gated render)
 * @param {string} modeKey - Backend mode value, expected one of 'flashcards' | 'exam' | 'adaptive'
 * @returns {string} - Localized mode name, or modeKey unchanged if unknown
 */
export function getLocalizedMode(t, modeKey) {
  const validModes = ['flashcards', 'exam', 'adaptive'];
  if (!validModes.includes(modeKey)) {
    return modeKey;
  }
  return t(`study:log.mode_names.${modeKey}`);
}
